const DDT_STATUS_LABELS = {
    OPEN: 'Aperta',
    CLOSED: 'Chiusa',
    APERTA: 'Aperta',
    CHIUSA: 'Chiusa',
    IN_CONTROLLO: 'In controllo',
    DA_FATTURARE: 'Da fatturare',
    FATTURATA: 'Fatturata',
}

const DDT_STATUS_COLORS = {
    OPEN: 'processing',
    CLOSED: 'default',
    APERTA: 'processing',
    CHIUSA: 'default',
    IN_CONTROLLO: 'gold',
    DA_FATTURARE: 'warning',
    FATTURATA: 'success',
}

export const normalizeDdtStatus = (status) => String(status || '').trim().toUpperCase()

export const getDdtStatusLabel = (status) => {
    const normalizedStatus = normalizeDdtStatus(status)
    return DDT_STATUS_LABELS[normalizedStatus] || (status ? String(status) : '-')
}

export const getDdtStatusColor = (status) =>
    DDT_STATUS_COLORS[normalizeDdtStatus(status)] || 'default'

// Stati che tolgono un DDT dal flusso "Da fatturare" del ciclo passivo: gia'
// confluito in una fattura oppure chiuso a magazzino. DA_FATTURARE non c'e':
// e' il DDT tornato in coda dopo uno storno, il cui state resta CLOSED.
const DDT_PASSIVE_CLOSED_STATUSES = new Set(['FATTURATA', 'CLOSED', 'CHIUSA'])

export const isDdtChiusoPerCicloPassivo = (status) =>
    DDT_PASSIVE_CLOSED_STATUSES.has(normalizeDdtStatus(status))

export const DDT_STATUS_FILTERS = [
    { text: 'Aperta', value: 'OPEN' },
    { text: 'Chiusa', value: 'CLOSED' },
]
